import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SectionHeader from '../components/SectionHeader';
import TestComponent from '../components/TestComponent';
import ContactImg from '../assets/img/contactImg.jpg';
import PurpleBtn from '../components/btns/PurpleBtn';
import Swal from 'sweetalert2';
// import { useTranslation } from 'react-i18next';

const ContactPage = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  // const { t } = useTranslation();
  

  const handleSubmit = () => {
    // Validate if any input is empty
    if (!firstName || !lastName || !message) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Zəhmət olmasa boşluqları doldurun'
      });
      return;
    } else {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: 'Əməliyyat tamamlandı',
        showConfirmButton: false,
        timer: 1500
      });
  
      // If all fields are filled, navigate to '/'
      navigate('/');
    }
  };

  return (
    <section className='pt-[60px] pb-[32px]'>
      <SectionHeader title='Əlaqə' />
      <div className='flex justify-center container'>
        {/* Content Container */}
        <div className='max-w-[600px] flex-grow'>
          <div className='grid grid-cols-2 gap-[20px] mb-5 max-[450px]:grid-cols-1'>
            <input
              type="text"
              placeholder='Adınız'
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className='bg-main text-white p-4 border border-[2px] border-purple rounded-[12px] outline-none'
            />
            <input
              type="text"
              placeholder='Soyadınız'
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className='bg-main text-white p-4 border border-[2px] border-purple rounded-[12px] outline-none'
            />
          </div>
          <TestComponent />
          <textarea
            className='p-4 border border-[2px] border-purple bg-main text-white outline-none w-full rounded-[12px] min-h-[200px] mt-4'
            placeholder='Mesajınız'
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <PurpleBtn title='Göndər' onClick={handleSubmit} />
        </div>

        {/* Image Container */}
        <div
          className='flex-grow max-w-[600px] ml-6 rounded-[12px] bg-cover bg-center max-[1020px]:hidden'
          style={{
            backgroundImage: `url(${ContactImg})`,
            height: 'auto',
          }}
        />
      </div>
    </section>
  );
};

export default ContactPage;